import { EndScreenProps, TestEndScreen } from '@project-minerva/assessment-player'

export const ExaminationEndScreen = (props: EndScreenProps) => <TestEndScreen {...props} />
